import React, { Component } from "react";
import PageProjectsThumb from './PageProjectsThumb';
import PageArchive from './PageArchive';

export default class PageProjects extends Component {

	constructor(props) {
		super(props)
		this.onIntersection = this.onIntersection.bind(this)
		this.state = {
			inView: false,
		}
	}

	componentDidMount() {
		if (this.$box) {
			let loadObserver;
			let options = {
				root: null,
				rootMargin: "-20% 0px -20% 0px",
				threshold: 0
			};
			let observer = new IntersectionObserver(this.onIntersection, options);
			observer.observe(this.$box);
		}
	}

	onIntersection(entries, observer) {
	    entries.map((entry) => {
			if (entry.intersectionRatio > 0 && this.state.inView === false) {
				this.setState({ inView: true });
			}						
		});
	} 
		  	
	render () {
		
		let block = this.props.block;
										
	    return (
		    
		    <>
		    
				<div id={block.id} className={'c-page__block ' + (this.state.inView ? "state-in-view" : "")} ref={(box) => { this.$box = box; }}>
			     
					<div className="c-projects">
				    
				    	<div className="c-projects__inner">
				    				    			
			    			{block.project.map((project,i) =>
								{
									return (
										<PageProjectsThumb item={project} key={i} index={i}></PageProjectsThumb>
									)
								}
							)}
							
							<div className="c-projects__vr c-projects__vr--1"></div>
							    				    					    
						</div>
						
					</div>
					
			    </div>
			    
			    <PageArchive block={block} />
		    
		    </>
		)
	}
}
